(()=>{
  if(window.qrCollectionPreviewBound)return;
  window.qrCollectionPreviewBound=true;
  let returnFocus;
  document.addEventListener('click',event=>{
    const browse=event.target.closest('[data-qr-collection-browse]');
    if(browse){const grid=document.querySelector('.qr-collection-grid');if(grid){event.preventDefault();grid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}return;}
    const button=event.target.closest('[data-qr-collection-preview]');
    if(!button||!button.closest('.qr-collection-grid'))return;
    const dialog=document.querySelector('[data-qr-collection-dialog]');
    if(!dialog)return;
    event.preventDefault();event.stopPropagation();
    const image=dialog.querySelector('[data-qr-collection-dialog-image]');
    const title=button.dataset.previewTitle||'';
    let rounds=[];try{rounds=JSON.parse(button.dataset.previewRounds||'[]');}catch{}
    if(!Array.isArray(rounds)||rounds.length!==7)return;
    image.src=button.dataset.previewImage;image.alt=title;
    dialog.querySelector('[data-qr-collection-dialog-title]').textContent=title;
    dialog.querySelector('[data-qr-collection-dialog-rounds]').replaceChildren(...rounds.map(round=>{const li=document.createElement('li');li.textContent=round;return li;}));
    const productLink=dialog.querySelector('[data-qr-collection-dialog-product]');
    productLink.href=button.dataset.previewUrl||button.closest('.qr-collection-card-gallery').querySelector('[ref="cardGalleryLink"]').href;
    const context=button.closest('[data-qr-collection-context]');
    if(context){const style=getComputedStyle(context);for(const name of ['paper','ink','heading','accent'])dialog.style.setProperty('--qr-col-'+name,style.getPropertyValue('--qr-col-'+name));}
    returnFocus=button;dialog.showModal();dialog.querySelector('.qr-collection-dialog-close').focus();
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const dialog=event.target.closest?.('[data-qr-collection-dialog]');
    if(!dialog?.open)return;
    const controls=[...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex=\"0\"]')].filter(element=>element.getClientRects().length&&!element.hidden);
    const first=controls[0],last=controls[controls.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  document.addEventListener('close',event=>{if(event.target.matches?.('[data-qr-collection-dialog]')&&returnFocus?.isConnected)returnFocus.focus();},true);
  document.addEventListener('click',event=>{const dialog=event.target;if(!dialog.matches?.('[data-qr-collection-dialog]'))return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
})();
